function optimizelyEvent(eventName, variantName) {
    var _a, _b;
    /* eslint-disable */
    (_b = (_a = window.optimizely) === null || _a === void 0 ? void 0 : _a.push) === null || _b === void 0 ? void 0 : _b.call(_a, { type: 'event', eventName: eventName, tags: { title: variantName } });
    /* eslint-enable */
}
export const trackImpression = (track, variant) => {
    track.impression({
        label: 'social-proof-experiment-impression',
    });
    optimizelyEvent('spe-social-proof-impression', variant);
};
// export const trackClickSignInInTooltip = (track: ModuleTrackingFunction, variant: string) => {
// 	track.click({
// 		label: 'social-proof-experiment-click-sing-in-in-tooltip',
// 	});
// 	optimizelyEvent('spe-click-sing-in-in-tooltip-click', variant);
// };
export const trackClickSignInBelowToC = (track, variant) => {
    track.click({
        label: 'social-proof-experiment-click-sing-in-below-toc',
    });
    optimizelyEvent('spe-click-sing-in-below-toc-click', variant);
};
// export const trackDisplayTooltipImpression = (track: ModuleTrackingFunction, variant: string) => {
// 	track.impression({
// 		label: 'social-proof-experiment-display-stats-display-tooltip',
// 	});
// 	optimizelyEvent('spe-display-stats-display-tooltip', variant);
// };
export const trackMouseOverContributionStatsBelowToC = (track, variant) => {
    track.hover({
        label: 'social-proof-experiment-display-stats-mouse-over-contribution-stats-below-toc',
    });
    optimizelyEvent('spe-display-stats-mouse-over-contribution-stats-below-toc', variant);
};
// export const trackClickContributionsStatsBelowEdit = (track: ModuleTrackingFunction) => {
// 	track.click({
// 		label: 'social-proof-experiment-display-stats-click-contribution-stats-below-edit',
// 	});
// };
export const trackClickContributionsStatsBelowToC = (track, variant) => {
    track.click({
        label: 'social-proof-experiment-display-stats-click-contribution-stats-below-toc',
    });
    optimizelyEvent('spe-display-stats-click-contributionStats-below-toc', variant);
};
